import consola from "consola";
import { useAccountStore } from "./pinia/account";

const console = consola.create({}).withTag("tracking");

window.TrackItem = function (itemType, itemId) {
    console.log("tracking item", itemType, itemId);
    var zaTrackerLocation = window.__zaTrackerLocation;
    try {
        $.getScript(zaTrackerLocation + "zaTracker/za.js", function (script) {
            window.ZiberTracker.getTracker(
                zaTrackerLocation + "zaTracker/trackItem"
            ).trackItemView("fiep", itemType, itemId);
        });
    } catch (e) {
        if (typeof console !== "undefined") {
            console.error(e);
        }
    }
};

window.TrackPersonalItem = function (itemType, itemId, metricType) {
    const store = useAccountStore();

    console.log(
        "tracking personal item",
        itemType,
        itemId,
        metricType,
    );
    var zaTrackerLocation = window.__zaTrackerLocation;
    try {
        $.getScript(zaTrackerLocation + "zaTracker/za.js", function (script) {
            window.ZiberTracker.getTracker(
                zaTrackerLocation + "zaTracker/trackPersonalItem"
            ).trackPersonalItemView(
                "fiep",
                itemType,
                itemId,
                store.user.id,
                metricType
            );
        });
    } catch (e) {
        if (typeof console !== "undefined") {
            console.error(e);
        }
    }
};

window.TrackPersonalSummaryItem = function (itemType, itemId) {
    window.TrackPersonalItem(itemType, itemId, "DisplaySummary");
};

window.TrackPersonalDetailsItem = function (itemType, itemId) {
    window.TrackPersonalItem(itemType, itemId, "DisplayDetails");
};
